<template>
  <div class="input">
    <Icon
      class="icon"
      name="magnifier"
      size="24" />
    <input
      :type="type"
      :value="value"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)" />
    <Icon
      v-if="clearable && value"
      class="icon-clear"
      name="remove"
      @click.native="clearValue"
      size="20" />
  </div>
</template>

<script>

export default {
  props: {
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: 'Placeholder',
    },
    value: {
      type: [String, Number],
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    };
  },
  methods: {
    clearValue() {
      this.$emit('clear-value', true)
    }
  }
}
</script>
<style>
  .input.iconed .icon-clear {
    cursor: pointer;
    position: absolute !important;
    top: 53% !important;
    right: 8px !important;
    left: initial!important;
    transform: translateY(-50%);
  }
</style>
